// noinspection JSPotentiallyInvalidUsageOfThis

import { nanoid } from 'nanoid'
import { preloadIcon } from "./SVG";

declare global {
  namespace preact.createElement.JSX {
    interface IntrinsicElements {
      ['sg-spoiler']: React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      >
    }
  }
}

const openedCache = {}
const eyeIcon = '<svg xmlns="http://www.w3.org/2000/svg" class="eye-opened" fill="none" viewBox="0 0 24 24"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 16.65a4.65 4.65 0 1 0 0-9.3 4.65 4.65 0 0 0 0 9.3Zm0-1.5A3.14 3.14 0 0 1 8.85 12 3.12 3.12 0 0 1 12 8.85a3.16 3.16 0 0 1 0 6.3Z"/><path d="M12 19.99a9.99 9.99 0 0 0 6.84-2.86 14.31 14.31 0 0 0 3.28-4.63 1.3 1.3 0 0 0 0-1c-.53-1.3-1.63-3.1-3.28-4.63A10 10 0 0 0 12 4a10 10 0 0 0-6.83 2.86 13.73 13.73 0 0 0-3.29 4.63 1.3 1.3 0 0 0 0 1 14.37 14.37 0 0 0 3.28 4.63A9.99 9.99 0 0 0 12 20Zm5.82-12.03a11.98 11.98 0 0 1 2.9 4.04 12.6 12.6 0 0 1-2.9 4.04A8.51 8.51 0 0 1 12 18.5a8.51 8.51 0 0 1-5.82-2.46A12.62 12.62 0 0 1 3.3 12a12 12 0 0 1 2.89-4.04A8.51 8.51 0 0 1 12 5.5a8.51 8.51 0 0 1 5.82 2.46Z"/></g></svg>'
const eyeSlashIcon = '<svg xmlns="http://www.w3.org/2000/svg" class="eye-closed" fill="none" viewBox="0 0 24 24"><g fill="currentColor"><path d="m11.46 8.96.17-.03c.14-.03.24-.05.34-.05a3.12 3.12 0 0 1 3.1 2.93l.01.08 1.36 1.07.04-.3a4.56 4.56 0 0 0-4.52-5.21c-.55-.01-1.1.13-1.6.33l-.04.01-.29.12 1.35 1.07.08-.02Z"/><path d="m18.77 14.8.11-.15c.75-.96 1.29-1.87 1.6-2.58l.03-.07-.03-.07a11.74 11.74 0 0 0-2.8-3.88A8.31 8.31 0 0 0 12 5.65a7.63 7.63 0 0 0-3.54.88l-.1.05-1.23-.97.23-.13A9.18 9.18 0 0 1 12 4.18c2.8 0 5.05 1.3 6.67 2.81a13.35 13.35 0 0 1 3.2 4.52c.13.32.13.66 0 .98-.35.85-.98 1.96-1.86 3.07l-.1.13-1.14-.89Zm4.01 4.79c.32.25.35.68.12 1.02a.73.73 0 0 1-1.01.12L1.22 4.4a.72.72 0 0 1 .9-1.14L22.77 19.6Zm-7.24-2.12.1-.05 1.23.97-.23.13a9.27 9.27 0 0 1-4.67 1.27 9.73 9.73 0 0 1-6.64-2.78 14.03 14.03 0 0 1-3.2-4.52 1.27 1.27 0 0 1 0-.98c.35-.85.98-1.96 1.86-3.07l.1-.13 1.14.89-.11.14c-.74.92-1.28 1.86-1.62 2.56l-.04.07.04.08a12.7 12.7 0 0 0 2.81 3.9 8.3 8.3 0 0 0 5.66 2.4c1.35 0 2.53-.34 3.57-.88Z"/><path d="M8.92 12.19a3.06 3.06 0 0 0 3.61 2.85l.08-.01 1.35 1.06-.28.12a4.54 4.54 0 0 1-6.2-4.67l.04-.2.04-.3 1.36 1.07v.08Z"/></g></svg>'

export class SgSpoiler extends HTMLElement {

  editable: boolean = false
  open: boolean = false
  transitionEnd: boolean = false
  connected = false
  uuid: string = ''

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  // noinspection JSUnusedGlobalSymbols
  static get observedAttributes() {
    return ['title'];
  }

  // noinspection JSUnusedGlobalSymbols
  connectedCallback() {
    if (this.connected) {
      return;
    }

    this.uuid = nanoid()
    this.title = this.getAttribute('title') || 'Скрытый текст'
    this.editable = this.parentElement.contentEditable === 'true' || !!this.getAttribute('editable') || !!this.getAttribute('data-editable') || false
    this.open = openedCache[this.uuid] ?? (this.getAttribute('open') === '' || this.getAttribute('data-open') === '')
    openedCache[this.uuid] = this.open
    this.setAttribute('attached', 'true')
    // noinspection JSIgnoredPromiseFromCall
    this.render()
    this.connected = true
  }

  // noinspection JSUnusedGlobalSymbols
  attributeChangedCallback(attrName: string, oldVal: string, newVal: string) {
    if (attrName === 'title' && oldVal !== newVal) {
      const title = this.shadowRoot.querySelector('.spoiler-caption span[data-spoiler-title]')
      if (title) {
        title.innerHTML = newVal
      }
    }
    if (attrName === 'data-editable' && oldVal !== newVal) {
      this.editable = newVal === 'true'
    }
  }

  preventEnter = (event: KeyboardEvent) => {
    event.stopPropagation()
    if (event.key === 'Enter') {
      event.preventDefault()
      return false
    }
  }

  setTitle = (event: KeyboardEvent & {
    target: HTMLSpanElement
  }) => {
    event.target.innerHTML = event.target.innerHTML.replace(/(<([^>]+)>)/gi, "");
    this.setAttribute('title', event.target.innerHTML)
    this.dispatchEvent(new CustomEvent('title-change', {
      detail: {
        title: event.target.innerHTML
      }
    }))
  }

  toggleSpoiler = () => {
    const spoiler = this.shadowRoot.querySelector<HTMLDivElement>('.sg-spoiler-root')
    spoiler.classList.toggle('open')
    openedCache[this.uuid] = spoiler.classList.contains('open')
  }

  removeSelf = (event: Event & {
    target: HTMLSlotElement
  }) => {
    const nodes = event.target.assignedNodes()
    if (nodes.length === 0
      || (nodes.length === 1 && nodes[0].nodeName === 'BR')) {
      this.remove()
    }
  }

  async render() {
    this.shadowRoot.innerHTML = `<style>
        .sg-spoiler-root { 
          margin: 15px 0 15px 0;
          border-radius: 8px;
          padding: 16px 24px;
          clear: both;
          background: var(--sg-spoiler-bg);
          color: var(--fg-color);
        }
        
        .sg-spoiler-root .spoiler-caption {
          user-select: none;
          font-size: 18px;
          line-height: 24px;
          font-weight: 400;
          position: relative;
          cursor: pointer;
          transition: .3s ease;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .sg-spoiler-root .spoiler-caption span {
          user-select: none;
        }
        
        .sg-spoiler-root .spoiler-caption.editable span {
          user-select: auto;
          flex-grow: 1;
        }
        
        .sg-spoiler-root .spoiler-caption .eye-opened,
        .sg-spoiler-root .spoiler-caption .eye-closed {
          width: 24px;
          height: 24px;
          color: var(--fg-color);
          vertical-align: top;
          margin-right: 4px;
        }
        
        .sg-spoiler-root .spoiler-caption .eye-opened {
          display: none;
        }
        
        .sg-spoiler-root .spoiler-caption .eye-closed {
          display: inline-block;
        }
        
        .sg-spoiler-root .spoiler-caption .arrow {
          width: 18px;
          height: 18px;
          color: var(--fg-color);
          display: inline-block;
          vertical-align: top;
          margin-left: 10px;
          margin-top: 1px;
          -webkit-transition: transform .3s ease-in-out;
          -o-transition: transform .3s ease-in-out;
          transition: transform .3s ease-in-out;
          will-change: transform;
          flex-shrink: 0;
        }
        
        .sg-spoiler-root.open .spoiler-caption .arrow {
          transform: scaleY(-1);
        }
        
        .sg-spoiler-root.open .spoiler-caption .eye-opened {
          display: inline-block;
        }
        
        .sg-spoiler-root.open .spoiler-caption .eye-closed {
          display: none;
        }
        
        .sg-spoiler-root .spoiler-caption input {
          border: 1px solid rgb(229 229 229);
          border-radius: 5px;
          font-size: 16px;
          font-weight: 500;
          text-transform: uppercase;
        }
        
        .sg-spoiler-root .spoiler-content {
          display: grid;
          grid-template-rows: 0fr;
          transition: grid-template-rows .3s ease-in-out;
          will-change: grid-template-rows;
          margin: 0 -24px;
        }
        
        .sg-spoiler-root .spoiler-content > div {
            overflow: hidden;
            transition: padding .3s ease-in-out;
            will-change: padding;
            padding: 0 24px;
        }
        
        .sg-spoiler-root.open .spoiler-content,
        .sg-spoiler-root .spoiler-content.editable {
          grid-template-rows: 1fr;
        }
        
        .sg-spoiler-root.open .spoiler-content > div,
        .sg-spoiler-root .spoiler-content.editable > div {
          padding: 16px 24px;
        }
        
        .sg-spoiler-root .spoiler-content.editable > div {
          overflow: visible;
        }
      </style><div class="sg-spoiler-root ${!this.open ? '' : 'open'} spoiler-${this.uuid}"><div class="spoiler-caption ${this.editable ? 'editable' : ''}"><span>${eyeIcon}${eyeSlashIcon}<span data-spoiler-title ${this.editable ? 'contentEditable' : ''}>${this.title}</span></span><svg viewBox="0 0 14 9" xmlns="http://www.w3.org/2000/svg" class="arrow"><path d="M13.25 1.5L7 7.75L0.75 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" /></svg></div><div class="spoiler-content ${this.editable ? 'editable' : ''}"><div><slot></slot></div></div></div>`
    const caption = this.shadowRoot.querySelector<HTMLDivElement>('.spoiler-caption');
    const captionText = caption.querySelector<HTMLSpanElement>('span[data-spoiler-title]');
    const body = this.shadowRoot.querySelector<HTMLDivElement>('.spoiler-content')
    const slot = body.querySelector('slot')

    if (this.editable) {
      captionText.addEventListener('beforeinput', (e) => e.stopPropagation())
      captionText.addEventListener('keydown', this.preventEnter)
      captionText.addEventListener('blur', this.setTitle)
      slot.addEventListener('slotchange', this.removeSelf)
    } else {
      caption.addEventListener('click', this.toggleSpoiler)
    }
  }
}

// Новый спойлер на Shadow DOM и Custom Elements
// noinspection JSUnusedGlobalSymbols
export default () => {
  const replaceOldSpoiler = (element: HTMLElement) => {
    element.querySelectorAll('spoiler').forEach(spoiler => {
      const newEl = document.createElement('sg-spoiler');

      // Copy the children
      while (spoiler.firstChild) {
        newEl.appendChild(spoiler.firstChild); // *Moves* the child
      }

      for (let i = spoiler.attributes.length - 1; i >= 0; --i) {
        newEl.attributes.setNamedItem(spoiler.attributes[i].cloneNode() as Attr);
      }

      // Replace it
      spoiler.parentNode.replaceChild(newEl, spoiler);
    })
  }

  let timeout: number

  const runAfterMutation = () => {
    replaceOldSpoiler(document.body);
  }

  const observer = new MutationObserver((_mutations) => {
    if (timeout) {
      clearTimeout(timeout)
    }
    // @ts-ignore
    timeout = setTimeout(runAfterMutation, 500)
  })

  replaceOldSpoiler(document.body);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  })

  preloadIcon('sg-new/eye')
  preloadIcon('sg-new/eye-slash')

  customElements.define('sg-spoiler', SgSpoiler)
}
